//import Ajv from "ajv";
import RecreationGovClient from "../externalclients/RecreationGovClient";
import ParkpassToR1SPassConverter from "../helpers/ParkpassToR1SPassConverter";
import moment from "moment";

export default class PassValidator {
  errors = {};

  validateLocally(pass, passMetadata, passDefinition, siteDefinition) {
    let fields = passMetadata.getAllFields();

    fields.forEach(fieldMetadata => {
      this.validateRequired(pass[fieldMetadata.name], fieldMetadata);
      this.validateFieldType(pass[fieldMetadata.name], fieldMetadata);
    });
    this.validateConfirmEmail(
      pass["visitoremail"],
      pass["visitoremailconfirm"]
    );

    let adultField = passMetadata.getField("adults");
    this.validateNumberOfAdults(pass["adults"], adultField);
    let childrenField = passMetadata.getField("children");
    this.validateNumberOfChildren(pass["children"], childrenField);

    //Create object to send to R1S
    //let converter = new ParkpassToR1SPassConverter();
    //let priceObject = converter.convert(pass);

    //Validate against JSON Schema - TODO: Revisit what to do with this.
    let passType = passDefinition.pass_types.find(type => {
      return type.id == pass.passtype;
    });
    if (!passType) {
      this.errors["passtype"] = "Please select a pass type.";
      return this.errors;
    }
    // let schema = passType.schema;
    // let ajv = new Ajv();
    // let valid = ajv.validate(schema, priceObject);
    //if (!valid) console.log(ajv.errors);

    //Validate acknolwedgement accepted
    this.validateAccepted(pass, passType);

    //Validate segments
    this.validateSegments(pass, passType);

    //Make sure start date is not a fee day
    this.validateFeeFreeDays(pass, siteDefinition);

    //Ensure start date is not incorrectly in the past
    this.validateStartDate(pass["start-date"], passType);

    this.validateBlackoutDates(pass["start-date"], passType, siteDefinition);

    return this.errors;
  }

  validateFeeFreeDays(pass, siteDefinition) {
    siteDefinition.free_days.forEach(day => {
      let passstartdate = moment.utc(pass["start-date"], "MM/DD/YYYY");
      let freedate = moment.utc(day.date);

      //Check if a date range
      if (day.end) {
        let enddate = moment.utc(day.end);
        let date = freedate;
        while (date <= enddate) {
          if (passstartdate.format("MM/DD/YYYY") == date.format("MM/DD/YYYY")) {
            this.errors["start-date"] =
              "Entrance fees are waived for " +
              day.name +
              ". Please select a different date.";
            return;
          }
          date.add(1, "days");
        }
      } else if (
        passstartdate.format("MM/DD/YYYY") == freedate.format("MM/DD/YYYY")
      ) {
        this.errors["start-date"] =
          "Entrance fees are waived for " +
          day.name +
          ". Please select a different date.";
      }
    });
  }

  validateSegments(pass, passType) {
    if (!passType.features["day-segment"]) {
      return;
    }
    if (
      (!pass.days || pass.days.length == 0) &&
      (!pass.nights || pass.nights.length == 0)
    ) {
      this.errors["segments"] = "Please select at least one day/night.";
    } else {
      this.errors["segments"] = "";
    }
  }

  validateWithJsonSchema() {}
  validateAccepted(pass, passType) {
    if (passType.features && passType.features.accepted) {
      if (passType.features.accepted.includes("need_to_know"))
        if (!pass["accepted"] || pass["accepted"] == false) {
          this.errors["accepted"] =
            "Please accept the acknowledgement to continue.";
        } else {
          this.errors["accepted"] = "";
        }

      if (passType.features.accepted.includes("return_policy")) {
        if (!pass["returnpolicy"] || pass["returnpolicy"] == false) {
          this.errors["returnpolicy"] =
            "Please accept the acknowledgement to continue.";
        } else {
          this.errors["returnpolicy"] = "";
        }
      }
    }
  }

  validateServerSideAndGetPrice(pass) {
    let converter = new ParkpassToR1SPassConverter();
    let priceObject = converter.convert(pass);
    let client = new RecreationGovClient();
    return client.validateAndGetPrice(priceObject);
  }

  validateRequired(value, fieldMetadata) {
    //Check required
    if (fieldMetadata.isRequired) {
      if (!value || value === "") {
        this.errors[fieldMetadata.name] = fieldMetadata.label + " is required.";
      } else {
        this.errors[fieldMetadata.name] = "";
      }
    }
  }

  validateFieldType(value, fieldMetadata) {
    if (fieldMetadata.dataType === "Number") {
      if (value) {
        if (isNaN(value)) {
          this.errors[fieldMetadata.name] =
            fieldMetadata.label + " must be a number.";
        }
      }
    }

    if (fieldMetadata.dataType === "Email") {
      if (value) {
        let emailRegex = /\S+@\S+\.\S+/;
        if (!emailRegex.test(value)) {
          this.errors[fieldMetadata.name] = "Invalid email address.";
        }
      }
    }
  }

  validateConfirmEmail(visitoremail, visitoremailconfirm) {
    if (visitoremail && visitoremailconfirm) {
      if (visitoremail !== visitoremailconfirm) {
        this.errors["visitoremailconfirm"] = "Email addresses do not match.";
      }
    }
  }

  validateNumberOfAdults(numberOfAdults, fieldMetadata) {
    if (fieldMetadata) {
      if (numberOfAdults < fieldMetadata.minValue) {
        this.errors["adults"] =
          "There must be at least " + fieldMetadata.minValue + " adult(s).";
      }
      if (
        numberOfAdults > fieldMetadata.maxValue &&
        fieldMetadata.maxValue != -1
      ) {
        this.errors["adults"] =
          "Pass is valid for up to " + fieldMetadata.maxValue + " adults.";
      }
    }
  }

  validateNumberOfChildren(numberOfChildren, fieldMetadata) {
    if (fieldMetadata) {
      if (numberOfChildren < fieldMetadata.minValue) {
        this.errors["children"] =
          "There must be at least " + fieldMetadata.minValue + " children.";
      }
      if (
        numberOfChildren > fieldMetadata.maxValue &&
        fieldMetadata.maxValue != -1
      ) {
        this.errors["children"] =
          "Pass is valid for up to " + fieldMetadata.maxValue + " children.";
      }
    }
  }

  validateStartDate(startDate, passType) {
    let passstartdate = moment(startDate, "MM/DD/YYYY");
    //For most pass types, start date can't be in the past.  The exception are seasonal/annual pass types that may have a start
    //date set for the beginning of the season, which may be in the past.
    if (passType.duration !== "season" && passType.duration !== "annual") {
      if (passstartdate.isBefore(moment(), "day")) {
        this.errors["start-date"] = "Start date cannot be in the past.";
      }
    }
  }

  validateBlackoutDates(startDate, passType, passDefinition) {
    if (passDefinition.blackout_periods) {
      passDefinition.blackout_periods.forEach(period => {
        let start = moment(startDate, "MM/DD/YYYY");
        let blackout_start = moment(period.start_date, "YYYY-MM-DD");
        let blackout_end = moment(period.end_date, "YYYY-MM-DD");
        if (
          start >= blackout_start &&
          start <= blackout_end &&
          passType.duration != "annual"
        ) {
          this.errors["start-date"] = period.description;
        }
      });
    }
  }
}
